<template>
  <section class="bg-default section-md">
    <div class="container">
      ДОСТУП ЗАПРЕЩЕН
    </div>
  </section>
</template>

<script>

export default {
  components: {
  },
  data() {
    return {

    }
  },
  name: "Page403E",
  created() {

  },
  methods: {

  },
  computed: {

  }
};
</script>
